import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosAuth } from "../config/axiosInstance";
import { PERSONALISED_VIDEO_PLAYER_BACKEND_BASE_URL } from "../config/api_config";
import { resolveCourseId, resolveModuleSlug } from "../utilities/videoPlayerApi";

const getLessonKey = ({ course_id, module_slug, lesson_id }) =>
    `${course_id || ''}|${module_slug || ''}|${lesson_id ?? ''}`;

export const fetchKeyTakeaways = createAsyncThunk(
    'keyTakeaway/fetchKeyTakeaways',
    async ({ course_id, module_slug, video_id, goal, lesson_id }, { getState }) => {
        const courseId = resolveCourseId(getState(), course_id);
        const moduleSlug = resolveModuleSlug(module_slug);
        const response = await axiosAuth.post(
            `${PERSONALISED_VIDEO_PLAYER_BACKEND_BASE_URL}/api/v1/courses/${courseId}/modules/${moduleSlug}/lessons/${lesson_id}/keypoints`,
            { goal: goal || null, video_id: video_id || null }
        );
        return response.data;
    }
);

const keyTakeawaySlice = createSlice({
    name: 'keyTakeaway',
    initialState: {
        result: {},
        keypointsFor: null,
        keypointsLoading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchKeyTakeaways.pending, (state) => {
                state.keypointsLoading = true;
            })
            .addCase(fetchKeyTakeaways.fulfilled, (state, action) => {
                state.keypointsLoading = false;
                state.result = action.payload ?? {};
                state.keypointsFor = getLessonKey({
                    course_id: action.meta.arg.course_id,
                    module_slug: action.meta.arg.module_slug,
                    lesson_id: action.meta.arg.lesson_id,
                });
            })
            .addCase(fetchKeyTakeaways.rejected, (state) => {
                state.keypointsLoading = false;
            });
    },
});

export const selectKeyTakeaway = (state) => state.keyTakeaway;
export const selectKeypointsGeneratedForLesson = (state, courseId, moduleSlug, lessonId) =>
    state.keyTakeaway?.keypointsFor === getLessonKey({
        course_id: courseId,
        module_slug: moduleSlug,
        lesson_id: lessonId,
    });
export const selectGeneratedKeypoints = (state, courseId, moduleSlug, lessonId) => {
    if (!selectKeypointsGeneratedForLesson(state, courseId, moduleSlug, lessonId)) return [];
    return state.keyTakeaway?.result?.keypoints ?? [];
};
export default keyTakeawaySlice.reducer;
